module.exports = __webpack_public_path__ + "static/media/SunflowerGreen.c980845a.svg";